import React from 'react';
import { Card, Tag } from 'antd';
import { InfoCircleOutlined, CalendarOutlined, TeamOutlined, UserOutlined, BellOutlined } from '@ant-design/icons';
import { formatDateTime, formatLeadSource } from '../../../../utils/functions';

const EnhancedNewLeadAlertDetails = ({ data }) => {
    if (!data) return null;

    const leadSourceName = formatLeadSource(data?.leadSourceId?.leadSource);
    const alertContact = data.alertEmail || data.alertSms;
    const alertType = data.alertEmail ? "Email" : "SMS";

    return (
        <div className="sm:!p-6 p-2 bg-gray-50 min-h-full">
            <Card className="shadow-sm mb-6">
                <h3 className="text-base font-semibold text-gray-700 mb-4 border-b pb-2 flex items-center gap-2">
                    <InfoCircleOutlined />
                    Alert Details
                </h3>

                <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                        <div className="p-3 bg-white border border-gray-100 rounded-md">
                            <p className="text-sm text-gray-500 mb-1 flex items-center gap-1">
                                <UserOutlined /> Lead Source
                            </p>
                            <p className="text-base font-medium text-gray-800 capitalize">
                                {leadSourceName || "-"}
                            </p>
                        </div>

                        <div className="p-3 bg-white border border-gray-100 rounded-md">
                            <p className="text-sm text-gray-500 mb-1 flex items-center gap-1">
                                <TeamOutlined /> Lead(s)
                            </p>
                            <p className="text-base font-medium text-gray-800">
                                {data.leadsImported || "0"}
                            </p>
                        </div>
                    </div>

                    <div className="p-3 bg-white border border-gray-100 rounded-md">
                        <div className="flex justify-between items-center mb-1">
                            <p className="text-sm text-gray-500 flex items-center gap-1">
                                <BellOutlined /> Alert Contact ({alertType})
                            </p>
                        </div>
                        <p className="text-base font-medium text-gray-800">
                            {alertContact || "-"}
                        </p>
                    </div>

                    <div className="p-3 bg-white border border-gray-100 rounded-md">
                        <p className="text-sm text-gray-500 mb-1 flex items-center gap-1">
                            <InfoCircleOutlined /> Detail
                        </p>
                        <p className="text-base font-medium text-gray-800 break-words">
                            {data.alertDetail || "-"}
                        </p>
                    </div>

                    <div className="p-3 bg-white border border-gray-100 rounded-md">
                        <p className="text-sm text-gray-500 mb-1 flex items-center gap-1">
                            <CalendarOutlined /> Imported At
                        </p>
                        <p className="text-base font-medium text-gray-800">
                            {formatDateTime(data.createdAt)}
                        </p>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default EnhancedNewLeadAlertDetails;
